import { render, staticRenderFns } from "./ConsultaCausacion.vue?vue&type=template&id=27657435"
import script from "./ConsultaCausacion.vue?vue&type=script&lang=js"
export * from "./ConsultaCausacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports